import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { LanguagesResultsResponse } from '../../../models/languages/responses/api-languages-results-response.model';
import { LanguageTranslationMissingKeysResponse } from '../../../models/languages/responses/api-languages-translation-missing-keys-response.model';
import { LanguageTranslationsResultsResponse } from '../../../models/languages/responses/api-languages-translations-results-response.model';
import { LanguageTranslationsFiltersRequest } from '../../../models/languages/requests/api-languages-get-translations-request.model';

@Injectable({
  providedIn: 'root'
})
export class ApiLanguagesService {

  constructor(private apiService: ApiService) { }

  addLanguage(languageId: number, languageIso: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesAddLanguageUrl, { language_id: languageId, language_iso: languageIso }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editLanguage(languageId: number, languageIso: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesEditLanguageUrl, { language_id: languageId, language_iso: languageIso }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getLanguageTranslationsMissingKeys(languageId: number): Promise<LanguageTranslationMissingKeysResponse> {
    return new Promise<LanguageTranslationMissingKeysResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesGetLanguageTranslationsMissingKeysUrl, { language_id: languageId }, LanguageTranslationMissingKeysResponse).then(
        (data: LanguageTranslationMissingKeysResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  deleteLanguage(languageId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesDeleteLanguageUrl, { language_id: languageId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getLanguageTranslations(languageId: number, page: number, resultCount: number, filters: LanguageTranslationsFiltersRequest): Promise<LanguageTranslationsResultsResponse> {
    return new Promise<LanguageTranslationsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesGetLanguageTranslationsUrl, { language_id: languageId, page, result_count: resultCount, filters }, LanguageTranslationsResultsResponse).then(
        (data: LanguageTranslationsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addLanguageTranslation(languageId: number, translationKey: string, translationValue: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesAddLanguageTranslationUrl, { language_id: languageId, translation_key: translationKey, translation_value: translationValue }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editLanguageTranslation(languageId: number, translationId: number, translationKey: string, translationValue: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesEditLanguageTranslationUrl, { language_id: languageId, translation_id: translationId, translation_key: translationKey, translation_value: translationValue }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteLanguageTranslation(languageId: number, translationId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesDeleteLanguageTranslationUrl, { language_id: languageId, translation_id: translationId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  changeLanguageActiveState(languageId: number, isActive: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.languagesChangeLanguageActiveStateUrl, { language_id: languageId, is_active: isActive }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getLanguages(): Promise<LanguagesResultsResponse> {
    return new Promise<LanguagesResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.languagesGetLanguagesUrl, LanguagesResultsResponse).then(
        (data: LanguagesResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }
}
